import React from 'react';
import style from '../Skills/Skills.module.css';

const Skills = () => {
  const skillsData = [
    {
      icon: 'https://cdn1.iconfinder.com/data/icons/logotypes/32/badge-html-5-256.png',
      link: 'https://developer.mozilla.org/en-US/docs/Web/HTML',
    },
    {   
      icon: 'https://cdn1.iconfinder.com/data/icons/logotypes/32/badge-css-3-256.png',
      link: 'https://developer.mozilla.org/en-US/docs/Web/CSS',
    },
    {    
      icon: 'https://cdn1.iconfinder.com/data/icons/programing-development-8/24/java_script_logo-64.png',
      link: 'https://devdocs.io/javascript/'
    },
    {    
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg',
      link: 'https://nodejs.org/es'
    },
    {    
      icon: 'https://camo.githubusercontent.com/5c92eeb467fd5d2b1ef1c560e3c3c2f758a8d4e03a8136bda7b41a2d3d4a1b59/68747470733a2f2f72656163746e61746976652e6465762f696d672f6865616465725f6c6f676f2e737667',
      link: 'https://react.dev'
    },
    {     
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
      link: 'https://redux.js.org'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg',
      link: 'https://www.w3schools.com/cpp/'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg',
      link: 'https://www.postgresql.org'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg',
      link: 'https://www.mysql.com'
    },
    {
      icon: 'https://yt3.googleusercontent.com/ytc/AOPolaRc7yDXdUSv3Q9ROaNBRfV-UsXcna-_d65XFPcS1w=s900-c-k-c0x00ffffff-no-rj',
      link: 'https://expressjs.com'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg',
      link: 'https://getbootstrap.com'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/d00d0969292a6569d45b06d3f350f463a0107b0d/icons/webpack/webpack-original-wordmark.svg',
      link: 'https://webpack.js.org'
    },
    {
      icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg',
      link: 'https://www.typescriptlang.org'
    },
    {
      icon: 'https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667',
      link: 'https://git-scm.com'
    },
    {
      icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968350.png',
      link: 'https://docs.python.org/3/'
    },
    {
      icon: 'https://cdn-icons-png.flaticon.com/512/270/270832.png',
      link: 'https://codex.wordpress.org/es:'
    }
  ];

  return (
    <div className={style.containerSkills}>
      <h2 className={style.skillsTitle}>Habilidades</h2>
      <div className={style.skillsList}>
        {skillsData.map((skill) => (
          <div className={style.skill} key={skill.name}>
            <h3>
              <a href={skill.link} target="_blank" rel="noopener noreferrer">
                <img src={skill.icon} alt={skill.name} className={style.icon} />
              </a>{' '}
              {skill.name}
            </h3>

          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;